import { Add, UploadFile } from "@mui/icons-material";
import {
  Box,
  Button,
  List,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import { load } from "react-cookies";
import DialogAddTeacher from "../../components/dashboard/fg-teacher/dialog-add-teacher";
import DialogEditTeacher from "../../components/dashboard/fg-teacher/dialog-edit-teacher";
import TeacherListItem from "../../components/dashboard/teacher-list-item";
import LoadingView from "../../components/loading-view";
import Api from "../../utils/Api";
import { HbType, ResponseType } from "../../utils/ConstType";
import Constants from "../../utils/Constants";
import DialogUploadTeacher from "../../components/dashboard/fg-teacher/dialog-upload-teacher";
import DialogDeleteTeacher from "../../components/dashboard/fg-teacher/dialog-delete-teacher";

export default function Teachers() {
  const [isLoading, setIsLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [teachers, setTeachers] = useState<HbType.TeacherDataType[]>([]);
  const [isAddTeacher, setIsAddTeacher] = useState(false);
  const [isUploadTeacher, setIsUploadTeacher] = useState(false);
  const [teacherInEditMode, setTeacherInEditMode] =
    useState<HbType.TeacherDataType | null>(null);
  const [teacherInDeleteMode, setTeacherInDeleteMode] =
    useState<HbType.TeacherDataType | null>(null);

  const loginToken = useMemo(
    () => load(Constants.key.CookiesKey.loginToken),
    []
  );

  const filteredTeachers = useMemo(() => {
    let sft = teachers;
    if (searchQuery.length > 0) {
      const sq = (searchQuery || "").trim().toLowerCase();

      sft = sft.filter((o) => {
        if (
          (o.name || "").trim().toLowerCase().includes(sq) ||
          (o.email || "").trim().toLowerCase().includes(sq) ||
          (o.phone || "").trim().toLowerCase().includes(sq)
        ) {
          return true;
        }

        return false;
      });
    }

    return sft;
  }, [teachers, searchQuery]);

  // pagination

  const [paginLimit, setPaginLimit] = useState(10);
  const [paginCurrentPage, setPaginCurrentPage] = useState(1);
  const paginationRootRef = useRef(null);
  const paginationFooterRef = useRef(null);

  const paginPages = useMemo(() => {
    return Math.ceil(filteredTeachers.length / paginLimit);
  }, [paginLimit, filteredTeachers]);

  const footerContent = useMemo(() => {
    const buttons = [];

    for (var i = paginCurrentPage - 2; i < paginCurrentPage + 3; i++) {
      if (i === paginCurrentPage) {
        buttons.push(
          <Button variant="contained" color="info" disabled>
            {i}
          </Button>
        );
      } else if (i > 0 && i <= paginPages) {
        const x = i;
        buttons.push(
          <Button
            variant="contained"
            color="warning"
            onClick={() => setPaginCurrentPage(x)}
          >
            {i}
          </Button>
        );
      }
    }

    return (
      <Box
        sx={{
          display: "flex",
          gap: 1,
          fontSize: "22px",
        }}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={() => setPaginCurrentPage(1)}
        >
          {"< First"}
        </Button>

        {buttons}

        <Button
          variant="contained"
          color="primary"
          onClick={() => setPaginCurrentPage(paginPages)}
        >
          {"Last >"}
        </Button>
      </Box>
    );
  }, [paginCurrentPage, paginPages]);

  //pagination

  useEffect(() => {
    functionHandler.getAllTeacher();
  }, []);

  const functionHandler = {
    getAllTeacher() {
      setIsLoading(true);
      Api.handler.teachers
        .all(loginToken)
        .then((response) => {
          // console.log("response is: ", response.data);
          const result = response.data as ResponseType;
          const tsrs = result.message as HbType.TeacherDataType[];
          setTeachers(tsrs);
        })
        .catch((err) => {})
        .finally(() => {
          setIsLoading(false);
        });
    },
  };

  return (
    <Box>
      {isLoading && <LoadingView />}
      {isAddTeacher && (
        <DialogAddTeacher
          onClose={() => setIsAddTeacher(false)}
          onUpdate={() => {
            setIsAddTeacher(false);
            functionHandler.getAllTeacher();
          }}
        />
      )}

      {isUploadTeacher && (
        <DialogUploadTeacher
          onClose={() => setIsUploadTeacher(false)}
          onUpdate={() => {
            setIsUploadTeacher(false);
            functionHandler.getAllTeacher();
          }}
        />
      )}

      {teacherInEditMode && (
        <DialogEditTeacher
          teacher={teacherInEditMode}
          onClose={() => setTeacherInEditMode(null)}
          onUpdate={() => {
            functionHandler.getAllTeacher();
            setTeacherInEditMode(null);
          }}
        />
      )}

      {teacherInDeleteMode && (
        <DialogDeleteTeacher
          teacher={teacherInDeleteMode}
          onClose={() => setTeacherInDeleteMode(null)}
          onDeleted={() => {
            setTeachers((o) =>
              o.filter((x) => x.id !== teacherInDeleteMode.id)
            );
            setTeacherInDeleteMode(null);
          }}
        />
      )}

      <Box
        sx={{
          display: "flex",
          gap: 0.5,
          alignItems: "flex-start",
          justifyContent: "space-between",
          width: "100%",
          flexWrap: "wrap",
          marginTop: 0.8,
          // height: 56,
          overflow: "hidden",
        }}
      >
        <Button
          sx={{ height: "100%" }}
          variant="contained"
          color="success"
          startIcon={<Add />}
          onClick={() => setIsAddTeacher(true)}
        >
          Add Teacher
        </Button>
        <Button
          sx={{ height: "100%" }}
          variant="contained"
          color="secondary"
          startIcon={<UploadFile />}
          onClick={() => setIsUploadTeacher(true)}
        >
          Upload
        </Button>
        <TextField
          sx={{ flexGrow: 1 }}
          placeholder="Search..."
          variant="standard"
          type="search"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </Box>

      {/* <List>
        {/* teacher lists *\/}
        {filteredTeachers &&
          filteredTeachers.map &&
          filteredTeachers?.map((t) => (
            <TeacherListItem
              teacher={t}
              onDelete={() => {
                setTeacherInDeleteMode(t);
              }}
              onEdit={() => setTeacherInEditMode(t)}
              key={t.id}
            />
          ))}
      </List> */}

      <Box
        ref={paginationRootRef}
        pt={1}
        sx={{
          height: `calc(100vh - ${
            (paginationRootRef.current || ({ offsetTop: 0 } as any)).offsetTop +
            64
          }px)`,
        }}
      >
        <Box
          sx={{
            height: "100%",
            border: 3,
            borderRadius: 2,
            borderColor:
              Constants.colors.lightTheme.palette.text.secondary + "35",
            p: 1,
            m: 0,
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",

            // display: flex;
            // justify-content: center;
            // align-items: center;
            // flex-direction: column;
          }}
        >
          <Box
            sx={{
              // height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              p: 1,
            }}
          >
            <Select
              autoWidth
              variant="outlined"
              size="small"
              value={paginLimit}
              onChange={(e) => setPaginLimit(Number(e.target.value))}
            >
              {[10, 25, 50, 100, 250].map((g) => (
                <MenuItem key={g} value={g}>
                  {g}
                </MenuItem>
              ))}
            </Select>
            <Typography> &nbsp;Record per page.</Typography>
          </Box>

          <Box
            sx={{
              // flex:1,
              // alignSelf: "stretch",
              boxSizing: "border-box",
              MozBoxSizing: "border-box",
              WebkitBoxSizing: "border-box",
              height: "100%",
              width: "100%",
              overflow: "auto",
              // backgroundColor: "red",

              // overflowY: "hidden",
            }}
          >
            <Box
              sx={{
                height: "100%",
                width: "100%",
                // backgroundColor: "yellow",
              }}
            >
              {filteredTeachers.length > 0 &&
                Array.apply(null, { length: paginLimit } as any)
                  .map(Number.call, Number)
                  .map(
                    (n: any) =>
                      filteredTeachers.length >
                        n + paginLimit * paginCurrentPage - paginLimit && (
                        <TeacherListItem
                          key={n}
                          teacher={
                            filteredTeachers[
                              n + paginLimit * paginCurrentPage - paginLimit
                            ]
                          }
                          onDelete={() =>
                            setTeacherInDeleteMode(
                              filteredTeachers[
                                n + paginLimit * paginCurrentPage - paginLimit
                              ]
                            )
                          }
                          onEdit={() =>
                            setTeacherInEditMode(
                              filteredTeachers[
                                n + paginLimit * paginCurrentPage - paginLimit
                              ]
                            )
                          }
                        />
                      )
                  )}
            </Box>
          </Box>

          <Box
            ref={paginationFooterRef}
            sx={{
              width: "100%",
              padding: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              // backgroundColor: "blue",
            }}
          >
            {footerContent}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
